import {
  RECEIVE_BOARD_SHARE_ID,
  SET_INITIAL_SORT
} from "../modules/savedItems/constants";
import { SET_ITEMS_TYPE } from "../modules/common/constants";
import { ITEMS_TYPE_SHARED_BOARD } from "../../constants";
import { initialise } from "./initialise/sharedBoard";

export const initialiseSharedBoard =
  ({ shareId, sortOption }) =>
  dispatch => {
    dispatch({
      type: SET_ITEMS_TYPE,
      payload: { itemsType: ITEMS_TYPE_SHARED_BOARD }
    });
    dispatch({
      type: SET_INITIAL_SORT,
      payload: sortOption
    });
    dispatch({
      type: RECEIVE_BOARD_SHARE_ID,
      payload: { shareId }
    });

    dispatch(initialise());
  };
